import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function ProtectedRoute({ children, requireSubscription = false }) {
  const { authenticated, loading, hasActiveSubscription, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <p>Loading...</p>
      </div>
    );
  }

  if (!authenticated) {
    return <Navigate to="/" replace />;
  }

  if (!user?.email_verified) {
    const emailParam = user?.email ? `?email=${encodeURIComponent(user.email)}` : '';
    return <Navigate to={`/verify-email${emailParam}`} replace />;
  }

  // If subscription is required but user doesn't have it (shouldn't happen if email is verified)
  if (requireSubscription && !hasActiveSubscription) {
    const emailParam = user?.email ? `?email=${encodeURIComponent(user.email)}` : '';
    return <Navigate to={`/verify-email${emailParam}`} replace />;
  }

  return children;
}

export default ProtectedRoute;
